import { ACTIVE_EXPERIMENTS, EXPERIMENT_KEYS } from '$lib/services/experiments/client/constants';
import { experimentService } from '$lib/services/experiments/client';
import { ProductExperienceService } from '$lib/services/product-experience';
import { AOFL_PRODUCT_NAMES } from '$lib/utils/constants';

/**
 *  @type {{[key: string]: import('$lib/utils/page').PageCondition}} conditions - The conditions object containing the conditions to be resolved.
 */
const pageConditions = {
	// In-app users should always be shown the in-app experience (and it should be the 1.0 version)
	inApp: {
		condition: async (config) => {
			return config.meta.inApp;
		},
		resolve: async () => {
			await ProductExperienceService.setProductExperience(AOFL_PRODUCT_NAMES.ABCMOUSE);
			return await import('../_in-app/Page.svelte');
		},
	},
	browser_2_0_rebrand_sweepstakes: {
		condition: async () => {
			const { experimentKey, variants } = ACTIVE_EXPERIMENTS.ABCM2_FAMILY_VACATION_GIVEAWAY;
			await experimentService.initializeExperiments([...EXPERIMENT_KEYS, experimentKey]);

			const assignedVariant = await experimentService.getExperimentArm(experimentKey, {
				page_name: 'home',
				page_url: '/abc',
			});

			return assignedVariant === variants.test;
		},
		resolve: async () => await import('../_browser-2-0-rebrand-sweepstakes/Page.svelte'),
	},
	default: {
		condition: async () => true,
		resolve: async () => {
			await experimentService.initializeExperiments([...EXPERIMENT_KEYS]);

			return await import('../_browser-2-0-rebrand/Page.svelte');
		},
	},
};

export { pageConditions };
